import { mpx } from '@didi/es-mpx-creator'
import { QUERY_REFUND_TICKET_REASON, QUERY_REFUND_TICKET_COST ,REFUND_TICKET} from '@/api/urls'

/**
 * @method 退票原因
 * @param data
 * @property {int} type -1为退票 2为改签
 * @returns {Promise}
 */
export const getRefundReason = (data) => {
  return mpx.$http.post(
    QUERY_REFUND_TICKET_REASON,
    { data }
  )
}

/**
 * @method 
 * @param {} data 
 * @property {string} data.order_id -订单id
 * @property {string} data.company_id -公司id
 * @property {int}   data.refund_type -退票类型 目前固定为1
 * @property {string } data.refund_info -退票信息
 * 
 * @param {string} refund_info 
 * @property {string} refund_info.ticket_id
 * @property {int} refund_info.company_pay
 * @property {int} refund_info.personal_pay
 * @property {string} refund_info.departure_time
 * @returns 
 */
export const queryRefundTicketCost = (data) => {
  return mpx.$http.post(
    QUERY_REFUND_TICKET_COST,
    { data }
  )
}

/**
 * @method 
 * @param {} data 
 * @property {string} data.supplier_order_id 
 * @property {string} data.order_id -订单id
 * @property {string } data.refund_tickets -退票信息
 * 
 * @param {string} refund_tickets 
 * @property {string} refund_tickets.ticket_id
 * @property {string} refund_tickets.refund_ticket_reason
 * @returns 
 */
export const refundTicket = (data) => {
  return mpx.$http.post(
    REFUND_TICKET, 
    { data }
  )
}
